import request, { Methods, withToken } from "../../../../utils/request";
import { getUserCompany } from "../../../../utils/constants";

//* ACTIONTYPES --------------------------------------------
export const POST_EMPLOYEE_REQUEST = "POST_EMPLOYEE_REQUEST";
export const POST_EMPLOYEE_SUCCESS = "POST_EMPLOYEE_SUCCESS";
export const POST_EMPLOYEE_ERROR = "POST_EMPLOYEE_ERROR";

//* ACTIONS ------------------------------------------------
export const postEmployeeRequest = (payload = {}, callback) => ({
  type: POST_EMPLOYEE_REQUEST,
  payload,
  callback,
});

export const postEmployeeSuccess = () => ({
  type: POST_EMPLOYEE_SUCCESS,
});

export const postEmployeeError = (error) => ({
  type: POST_EMPLOYEE_ERROR,
  payload: error,
});

//* REQUEST SERVICE ---------------------------------------
export const postEmployeeServiceRequest = async (data) => {
  const options = await withToken({
    method: Methods.POST,
    headers: { CompanyId: await getUserCompany() },
    data,
  });

  return request("/employees", options);
};
